// Pre-built library catalog — aggregates header styles, footer styles, and the
// per-industry starter templates into the structures the Pre-built tab renders.
import HEADERS from './headers'
import FOOTERS from './footers'
import banks from './banks'
import retail from './retail'
import ecommerce from './ecommerce'
import insurance from './insurance'
import fintech from './fintech'
import healthcare from './healthcare'
import fmcg from './fmcg'
import logistics from './logistics'

// Industry categories, in display order. `key` matches the file; `label` is shown.
export const PREBUILT_CATEGORIES = [
  { key: 'banks', label: 'Banks', templates: banks },
  { key: 'retail', label: 'Retail', templates: retail },
  { key: 'ecommerce', label: 'eCommerce', templates: ecommerce },
  { key: 'insurance', label: 'Insurance', templates: insurance },
  { key: 'fintech', label: 'FinTech', templates: fintech },
  { key: 'healthcare', label: 'Healthcare', templates: healthcare },
  { key: 'fmcg', label: 'FMCG', templates: fmcg },
  { key: 'logistics', label: 'Logistics', templates: logistics },
]

export const PREBUILT_HEADERS = HEADERS
export const PREBUILT_FOOTERS = FOOTERS
